import { supabase } from '@/lib/supabase'
import { mergeHeroFromRpc } from '@/lib/siteHeroConfig'

/**
 * Public landing hero (anon RPC). Returns merged defaults when unpublished or empty.
 */
export async function fetchPublicHero() {
  const { data, error } = await supabase.rpc('get_public_site_hero')
  if (error) {
    console.warn('fetchPublicHero:', error.message)
    return mergeHeroFromRpc(null)
  }
  return mergeHeroFromRpc(data)
}
